import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Name is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Name is required.'  }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'required', message: 'Fiancé\'s Name (If Applicable) is required.' }
      ]
    },
    eventextra4: {
        validations: [
          { type: 'required', message: 'Fiancé\'s Name (If Applicable) is required.' }
        ]
      },
    addressLine1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: [
        { type: 'required', message: 'State is required.' }
      ]
    },
    postal: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Email Address is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Contact Phone Number is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Event Type is required.' },
      ]
    },
    accountextra1: {
      validations: [
        { type: 'required', message: 'Date of Event is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    accountextra2: {
      validations: [
        { type: 'required', message: 'Start Time is required.' }
      ]
    },
    accountextra3: {
      validations: [
        { type: 'required', message: 'End Time is required.' }
      ]
    },
    accountextra4: {
      validations: [
        { type: 'required', message: 'How many guest\'s will attend? is required.' }
      ]
    },
    accountextra5: {
      validations: [
        { type: 'required', message: 'Location is required.' }
      ]
    },
    accountextra6: {
      validations: [
        { type: 'required', message: 'Service Style is required.' }
      ]
    },
    accountextra7: {
      validations: [
        { type: 'required', message: 'Bar Service is required.' }
      ]
    },
    accountextra8: {
      validations: [
        { type: 'required', message: 'Price is required.' }
      ]
    },
    accountextra9: {
      validations: [
        { type: 'required', message: 'Food & Beverage is required.' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'How did you hear about us? is required.' }
      ]
    },
    website: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'Additional information is required.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Name*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'First Name',
            mapping: 'headerLabel',
            customClasses: ['heading2']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'headerLabel',
            customClasses: ['heading2']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Fiancé\'s Name (If Applicable)*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Fiancé\'s Name (If Applicable)*',
            mapping: 'eventextra3',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'eventextra4',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'First Name',
            mapping: 'headerLabel',
            customClasses: ['heading2']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'headerLabel',
            customClasses: ['heading2']
          }
        ]
      },  {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Address',
              mapping: 'addressLine1'
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'City',
              mapping: 'city'
            },
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'State*',
              options: [
                { label: 'AL', value: 'AL' },
                { label: 'AK', value: 'AK' },
                { label: 'AZ', value: 'AZ' },
                { label: 'AR', value: 'AR' },
                { label: 'CA', value: 'CA' },
                { label: 'CO', value: 'CO' },
                { label: 'CT', value: 'CT' },
                { label: 'DE', value: 'DE' },
                { label: 'DC', value: 'DC' },
                { label: 'FL', value: 'FL' },
                { label: 'GA', value: 'GA' },
                { label: 'HI', value: 'HI' },
                { label: 'ID', value: 'ID' },
                { label: 'IL', value: 'IL' },
                { label: 'IN', value: 'IN' },
                { label: 'IA', value: 'IA' },
                { label: 'KS', value: 'KS' },
                { label: 'KY', value: 'KY' },
                { label: 'LA', value: 'LA' },
                { label: 'ME', value: 'ME' },
                { label: 'MD', value: 'MD' },
                { label: 'MA', value: 'MA' },
                { label: 'MI', value: 'MI' },
                { label: 'MN', value: 'MN' },
                { label: 'MS', value: 'MS' },
                { label: 'MO', value: 'MO' },
                { label: 'MT', value: 'MT' },
                { label: 'NE', value: 'NE' },
                { label: 'NV', value: 'NV' },
                { label: 'NH', value: 'NH' },
                { label: 'NJ', value: 'NJ' },
                { label: 'NM', value: 'NM' },
                { label: 'NY', value: 'NY' },
                { label: 'NC', value: 'NC' },
                { label: 'ND', value: 'ND' },
                { label: 'OH', value: 'OH' },
                { label: 'OK', value: 'OK' },
                { label: 'OR', value: 'OR' },
                { label: 'PA', value: 'PA' },
                { label: 'RI', value: 'RI' },
                { label: 'SC', value: 'SC' },
                { label: 'SD', value: 'SD' },
                { label: 'TN', value: 'TN' },
                { label: 'TX', value: 'TX' },
                { label: 'UT', value: 'UT' },
                { label: 'VT', value: 'VT' },
                { label: 'VA', value: 'VA' },
                { label: 'WA', value: 'WA' },
                { label: 'WV', value: 'WV' },
                { label: 'WI', value: 'WI' },
                { label: 'WY', value: 'WY' }
              ],
              mapping: 'state'
            },
            {
              type: 'text',
              size: 'Medium',
              label: 'Zip',
              mapping: 'postal'
            }
          ]
        },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact Phone Number*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'small',
            label: 'Date of Event*',
            mapping: 'accountextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Estimated Event Start Time*',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'accountextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Estimated Event End Time*',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type*',
            options: [
              { label: 'Wedding Ceremony and Reception' , value: 'Wedding Ceremony and Reception'},
              { label: 'Wedding Ceremony Only', value: 'Wedding Ceremony Only'},
              { label: 'Wedding Reception Only' , value: 'Wedding Reception Only'},
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner'},
              { label: 'Vow Renewal', value: 'Vow Renewal'},
              { label: 'Baby\'s First Luau', value: 'Baby\'s First Luau'},
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Birthday Party' , value: 'Birthday Party'},
              { label: 'Private Chef Experience', value: 'Private Chef Experience'},
              { label: 'Celebration of Life', value: 'Celebration of Life'},
              { label: 'Holiday Party', value: 'Holiday Party'},
              { label: 'Corporate Event', value: 'Corporate Event'},
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How many guests will attend?*',
            options:[
              {label: '10' , value: '10'},
              {label: '20' , value: '20'},
              {label: '30' , value: '30'},
              {label: '40' , value: '40'},
              {label: '50' , value: '50'},
              {label: '60' , value: '60'},
              {label: '70' , value: '70'},
              {label: '80' , value: '80'},
              {label: '90' , value: '90'},
              {label: '100' , value: '100'},
              {label: '110' , value: '110'},
              {label: '120' , value: '120'},
              {label: '130' , value: '130'},
              {label: '140' , value: '140'},
              {label: '150' , value: '150'},
              {label: '160' , value: '160'},
              {label: '170' , value: '170'},
              {label: '180' , value: '180'},
              {label: '190' , value: '190'},
              {label: '200' , value: '200'},
              {label: '210' , value: '210'},
              {label: '220' , value: '220'},
              {label: '230' , value: '230'},
              {label: '240' , value: '240'},
              {label: '250' , value: '250'},
              {label: '260' , value: '260'},
              {label: '270' , value: '270'},
              {label: '280' , value: '280'},
              {label: '290' , value: '290'},
              {label: '300+' , value: '300+'},
            ],
            mapping: 'accountextra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Location*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Where will the event take place?',
            mapping: 'headerLabel',
            customClasses: ['heading1']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Location*',
            options: [
              { label: 'Off-Site' , value: 'Off-Site'},
              { label: 'Pikake Pavilion', value: 'Pikake Pavilion'},
              { label: 'Main Lawn', value: 'Main Lawn'},
              { label: 'Upper Meadow' , value: 'Upper Meadow'},
              { label: 'Proud Peacock', value: 'Proud Peacock'},
              { label: 'Waterfall', value: 'Waterfall' },
              { label: 'Hale Ho\'ike' , value: 'Hale Ho\'ike'},
              { label: 'Undecided', value: 'Undecided'},
              { label: 'Amphitheater' , value: 'Amphitheater'},
            ],
            mapping: 'accountextra5',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Desired Service Style*',
            options: [
              { label: 'Drop-off Service not available at Waimea Valley' , value: 'Drop-off Service not available at Waimea Valley'},
              { label: 'Bar Only', value: 'Bar Only'},
              { label: 'Cake Only', value: 'Cake Only'},
              { label: 'Breakfast/Brunch Buffet', value: 'Breakfast/Brunch Buffet' },
              { label: 'Breakfast/Brunch Family-Style' , value: 'Breakfast/Brunch Family-Style'},
              { label: 'Breakfast/Brunch Plated', value: 'Breakfast/Brunch Plated'},
              { label: 'Breakfast/Brunch Station', value: 'Breakfast/Brunch Station' },
              { label: 'Lunch Buffet' , value: 'Lunch Buffet'},
              { label: 'Lunch Family-Style', value: 'Lunch Family-Style'},
              { label: 'Lunch Plated', value: 'Lunch Plated'},
              { label: 'Lunch Station', value: 'Lunch Station'},
              { label: 'Dinner Buffet', value: 'Dinner Buffet'},
              { label: 'Dinner Family-Style', value: 'Dinner Family-Style'},
              { label: 'Dinner Plated', value: 'Dinner Plated'},
              { label: 'Dinner Station', value: 'Dinner Station'},
            ],
            mapping: 'accountextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Desired Bar Service*',
            options: [
              { label: 'Open Bar (guests DO NOT pay for drinks)' , value: 'Open Bar (guests DO NOT pay for drinks)'},
              { label: 'Cash Bar (guests pay for drinks)', value: 'Cash Bar (guests pay for drinks)'},
              { label: 'Serve to a Limit (specified before hand)', value: 'Serve to a Limit (specified before hand)'},
              { label: 'No Bar', value: 'No Bar' }
            ],
            mapping: 'accountextra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Venue Price Comfort Zone*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue Price Comfort Zone*',
            options:[
              {label: '$0-$1000' , value: '$0-$1000'},
              {label: '$1000-$2000' , value: '$1000-$2000'},
              {label: '$2000-$3000' , value: '$2000-$3000'},
              {label: '$3000-$4000' , value: '$3000-$4000'},
              {label: '$4000-$5000' , value: '$4000-$5000'},
              {label: '$5000-$6000' , value: '$5000-$6000'},
              {label: '$6000-$7000' , value: '$6000-$7000'},
              {label: '$7000-$8000' , value: '$7000-$8000'},
              {label: '$8000-$9000' , value: '$8000-$9000'},
              {label: '$9000-$10000' , value: '$9000-$10000'},
              {label: '$10000-$11000' , value: '$10000-$11000'},
              {label: '$11000-$12000' , value: '$11000-$12000'},
              {label: '$12000-$13000' , value: '$12000-$13000'},
              {label: '$13000-$14000' , value: '$13000-$14000'},
              {label: '$14000-$15000' , value: '$14000-$15000'},
              {label: '$15000+' , value: '$15000+'},
            ],
            mapping: 'accountextra8',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Food & Beverage Comfort Zone*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please tell us your budget for all services rendered by Ke Nui Kitchen to include food, beverage, service, etc.',
            mapping: 'headerLabel',
            customClasses: ['heading1']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label:'',
            options:[
              {label: '$0-$1000' , value: '$0-$1000'},
              {label: '$1000-$2000' , value: '$1000-$2000'},
              {label: '$2000-$3000' , value: '$2000-$3000'},
              {label: '$3000-$4000' , value: '$3000-$4000'},
              {label: '$4000-$5000' , value: '$4000-$5000'},
              {label: '$5000-$6000' , value: '$5000-$6000'},
              {label: '$6000-$7000' , value: '$6000-$7000'},
              {label: '$7000-$8000' , value: '$7000-$8000'},
              {label: '$8000-$9000' , value: '$8000-$9000'},
              {label: '$9000-$10000' , value: '$9000-$10000'},
              {label: '$10000-$11000' , value: '$10000-$11000'},
              {label: '$11000-$12000' , value: '$11000-$12000'},
              {label: '$12000-$13000' , value: '$12000-$13000'},
              {label: '$13000-$14000' , value: '$13000-$14000'},
              {label: '$14000-$15000' , value: '$14000-$15000'},
              {label: '$15000+' , value: '$15000+'},
            ],
            mapping: 'accountextra9'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Additional information*',
            mapping: 'headerLabel',
            customClasses: ['heading0']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please elaborate on your wants and needs for this specific event, including desired cuisine types, specific dishes, dessert and/or cake requests, appetizer service, cocktail hour, and dietary restrictions or allergies. Providing more detailed information allows us to prepare the best proposal possible for your event. Tell us what your vision is!',
            mapping: 'headerLabel',
            customClasses: ['heading3']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?*',
            options: [
              { label: 'Repeat Client' , value: 'Repeat Client'},
              { label: 'Referral', value: 'Referral'},
              { label: 'Walk In', value: 'Walk In'},
              { label: 'Wedding Expo', value: 'Wedding Expo' },
              { label: 'Yellow Pages' , value: 'Yellow Pages'},
              { label: 'Wedding Planner', value: 'Wedding Planner'},
              { label: 'Web Search', value: 'Web Search' },
              { label: 'Yelp' , value: 'Yelp'},
              { label: 'Facebook', value: 'Facebook'},
              { label: 'Instagram', value: 'Instagram'}
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Ke Nui Kitchen Contact Form',
    formId: '343',
    clientKey: '60F4F897-4C01-427D-A109-C2A6BDF5DEBD',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
